import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        overlayClass: { type: String, default: 'show-overlay' }
    }

    showOverlay() {
        this.element.classList.add(this.overlayClassValue);
        window.dispatchEvent(new Event('resize'));
    }

    hideOverlay() {
        this.element.classList.remove(this.overlayClassValue);
    }

    documentClick(event) {
        if (this.element.contains(event.target)) {
            return;
        }

        this.hideOverlay();
    }
}
